export default {
  //* MIDDLEWARE
  // HEALTH
  RATER_CALCULATE_PRICE: '/Pricing/GetPricing',
  GET_RECOVERY: '/Recovery/GetRecovery',
  SAVE_QUOTATION: '/Save/SaveQuotation',
  SAVE_DOCUMENT: '/Save/SaveDocument',
  SAVE_DOCUMENT_INSURED: '/Save/SaveDocumentInsured',
  SAVE_HOLDER: '/Save/SavePolicyHolder',
  SAVE_PAYMENT: '/Save/SavePaymentMeans',
  POLICY_EMISSION: '/Emission',
  SAVE_INSUREDS: '/Save/SaveInsureds',
  // DENTAL
  RATER_CALCULATE_PRICE_DENTAL: '/Pricing/GetPricingDental',
  GET_RECOVERY_DENTAL: '/Recovery/GetRecoveryDental',
  SAVE_QUOTATION_DENTAL: '/Quotation/SaveDental',
  SAVE_DOCUMENT_DENTAL: '/Document/SaveDental',
  SAVE_HOLDER_DENTAL: '/PolicyHolder/SaveDental',
  SAVE_PAYMENT_DENTAL: '/PaymentMeans/SaveDental',
  POLICY_EMISSION_DENTAL: '/Emission/dental' /* {quotationId} as path param*/,
  SAVE_INSUREDS_DENTAL: '/Insured/SaveDental',
  // LIFE
  RATER_CALCULATE_PRICE_LIFE: '/Pricing/GetPricingLife',
  SAVE_QUOTATION_LIFE: '/Quotation/SaveLife',
  GET_RECOVERY_LIFE: '/Recovery/GetRecoveryLife',
  GET_PROFESSION: '/Typology/GetProfessionType',
  GET_ACTIVITY: '/Typology/GetActivityType',
  GET_INCREMENT_RISK: '/Typology/GetIncrementRisk',
  GET_REEVALUATION_OPTIONS: '/Typology/GetRevaluationType',
  SAVE_DOCUMENT_LIFE: '/Document/SaveLife',
  SAVE_HOLDER_LIFE: '/PolicyHolder/SaveLife',
  SAVE_INSUREDS_LIFE: '/Insured/SaveLife',
  SAVE_QUESTIONNAIRE_LIFE: '/Questionnaire/SaveLife',
  SAVE_BENEFICIARY_LIFE: '/Beneficiary/SaveLife',
  SAVE_PAYMENT_LIFE: '/PaymentMeans/SaveLife',
  POLICY_EMISSION_LIFE: '/Emission/life' /* {quotationId} as path param*/,
  //PETS
  RATER_CALCULATE_PRICE_PETS: '/Pricing/GetPricingPets',
  GET_RECOVERY_PETS: '/Recovery/GetRecoveryPets',
  SAVE_QUOTATION_PETS: '/Quotation/SavePet',
  SAVE_DOCUMENT_PETS: '/Document/SavePet',
  SAVE_HOLDER_PETS: '/PolicyHolder/SavePet',
  SAVE_PAYMENT_PETS: '/PaymentMeans/SavePet',
  SAVE_INSURED_PETS: '/Pet/SavePet',
  CIVIL_LIABILITY_RESPONSIBLE: '/InsuredRC/SavePet',
  GET_BREED: '/Typology/GetBreed',
  VALIDATE_CHIP: '/Typology/ValidateChip',
  // TRAVEL
  RATER_CALCULATE_PRICE_TRAVEL: '/Pricing/GetPricingTravel',
  GET_RECOVERY_TRAVEL: '/Recovery/GetRecoveryTravel',
  SAVE_QUOTATION_TRAVEL: '/Quotation/SaveTravel',
  SAVE_DOCUMENT_TRAVEL: '/Document/SaveTravel',
  SAVE_HOLDER_TRAVEL: '/PolicyHolder/SaveTravel',
  SAVE_INSURED_TRAVEL: '/Insured/SaveTravel',
  POLICY_EMISSION_TRAVEL: '/Emission/travel' /* {quotationId} as path param*/,
  // FOREIGN HEALTH
  RATER_CALCULATE_PRICE_FOREIGN_HEALTH: '/Pricing/GetPricing',
  GET_RECOVERY_FOREIGN_HEALTH: '/Recovery/GetRecovery',
  SAVE_QUOTATION_FOREIGN_HEALTH: '/Save/SaveQuotation',
  SAVE_DOCUMENT_FOREIGN_HEALTH: '/Save/SaveDocument',
  SAVE_DOCUMENT_INSURED_FOREIGN_HEALTH: '/Save/SaveDocumentInsured',
  SAVE_HOLDER_FOREIGN_HEALTH: '/Save/SavePolicyHolder',
  SAVE_INSURED_FOREIGN_HEALTH: '/Insured/SaveForeignHealth',
  POLICY_EMISSION_FOREIGN_HEALTH: '/Emission' /* {quotationId} as path param*/,
  SAVE_INSUREDS_FOREIGN_HEALTH: '/Save/SaveInsureds',
  // COMMON
  CLICK_TO_CALL: '/ClickToCall/ClickToCall',
  GET_POSTAL_CODES: '/PostalCode/GetCP',
  POST_CP_CODES: '/Address/Normalice/AutocompleteZip',
  VALIDATE_EMAIL: '/Email/validate',
  SEND_BUDGET: '/Email/sendEmailBudget',
  AUTOCOMPLETE_CITY: '/Address/Normalice/AutocompleteCity',
  AUTOCOMPLETE_STREET: '/Address/Normalice/AutocompleteStreet',
  NORMALIZE_ADDRESS: '/Address/Normalice',
  GET_ACCORDION_DOCUMENTS: '/Document/GetListDoc',
  DOWNLOAD_DOCUMENT_BY_REFERENCE: '/Document/DownloadDocumentByReference',
  DOWNLOAD_ACCORDION_DOCUMENT: '/Document/DownloadDoc',
  SAVE_QUESTIONNAIRE: '/Save/SaveQuestionnaire',
  SING_DOCUMENT: '/Document/Signature',
  MDW_GET_COVERAGES: '/Coverages/GetCoverages',
  MDW_GET_DOCUMENTS_BY_ROLE: '/DocumentType/ByInsuredRole',
  MDW_SEND_EMAIL_REQUEST: '/Email/SendEmailRequest',
  MDW_VALIDATE_LANDING: '/Landing/ValidationLanding',
  MDW_SEND_LANDING: '/Landing/SendEmailLanding',
  MDW_HEALTH_EXIST_CLIENT: '/Client/ExistClient',
  MID_GET_COVERAGES_COMPLETE: '/Coverages/GetCoveragesComplete',
  MID_GET_PROFESSION: '/Typology/GetProfessionType',
  MID_GET_ACTIVITY: '/Typology/GetActivityType',
  GET_COVERAGES_COMPLETE: '/Coverages/GetCoveragesComplete', // replace with MID_GET_COVERAGES_COMPLETE
  GET_PAYMENT_URL: '/Payment',
  GET_QR_NAME: '/DocumentQR/GetDocumentQRNames',
  GET_QR: '/DocumentQR/GetDocumentQR',
  SAVE_QR: '/DocumentQR/SaveDocumentQR',
  DELETE_QR: '/DocumentQR/DeleteDocumentQR',
  GET_INFO_MEDIATOR: '/Mediator/GetInfoMediator',

  //* DXP
  DXP_GET_BRANCHES_DATA: '/dxp-config.json',
  DXP_GET_BRANCHES_DATA_PYMES: '/dxp-config-pymes.json',
  DXP_GET_FOOTER_LINKS: '/footer.json',
  DXP_GET_BRANCH_HEALTH: '/dxp-config.health.json',
  DXP_GET_BRANCH_CONFIG: '/config.json',
  DXP_GET_BRANCH_DENTAL: '/dxp-config.dental.json',
  DXP_GET_BRANCH_LIFE: '/dxp-config.life.json',
  DXP_GET_BRANCH_PETS: '/dxp-config.pets.json',
  DXP_GET_BRANCH_TRAVEL: '/dxp-config.travel.json',
  DXP_GET_BRANCH_FOREIGN_HEALTH: '/dxp-config.health-foreign.json',
  DXP_GET_PROVINCES: '/provinces.json',
  DXP_GET_PRODUCT: '/products/getByLanguageAndIds.json', //?language=en&productId=1000
  DXP_GET_COUNTRIES: '/countries.json',
  DXP_GET_COVERAGES: '/coverages/getByLanguageAndIds.json',
  DXP_GET_COVERAGES_BASIC: '/coverages/getCoveragesBasicInfo.json',
  DXP_GET_ENTITIES: '/entities.json',
  DXP_GET_BANK_ENTITIES: '/bank-entities.json',
  DXP_GET_MAX_AGE_BY_BUSINESS_LINE: '/products/getByBusinessLineAndInsurance.json'
}
